import { useTranslate } from '@tolgee/react';
import { AppRoute } from '@agentselly/immodossier-shared';
import { AppLink } from '~/components/AppLink';
import { useAppParams } from '~/helper/useAppParams';

const Svg = ({ d, size }: { d: string; size: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d={d} />
  </svg>
);

interface Props {
  readonly title: string;
}

export function V3EmptyState({ title }: Props) {
  const { t } = useTranslate();
  const params = useAppParams();
  return (
    <div className="v3-overview stack">
      <div className="head">
        <h1>{title}</h1>
      </div>
      <div
        className="card stack state-empty"
        data-od-id="empty-block"
      >
        <span className="ico">
          <Svg
            size={24}
            d="M3 11l9-8 9 8M5 10v10h5v-6h4v6h5V10"
          />
        </span>
        <h2>{t('v3_property_edit_empty_title', 'Kein Objekt gewählt')}</h2>
        <p className="mu">
          {t(
            'v3_property_edit_empty_text',
            'Wählen Sie in der Übersicht ein Objekt, um die Angaben zu ergänzen.',
          )}
        </p>
        <div className="row wrap">
          <AppLink
            className="btn pri"
            to={AppRoute.$LANG_$COMPANYID_$CONTACTID_INDEX}
            params={params}
          >
            {t('dossier_delete_back_to_overview', 'Zur Übersicht')}
          </AppLink>
        </div>
      </div>
    </div>
  );
}

export function V3ErrorState({
  title,
  onRetry,
}: Props & { readonly onRetry: () => void }) {
  const { t } = useTranslate();
  return (
    <div className="v3-overview stack">
      <div className="head">
        <h1>{title}</h1>
      </div>
      <div
        className="card stack state-err"
        role="alert"
        data-od-id="error-block"
      >
        <span className="chip c-bad">
          <i />
          {t('v3_error_chip', 'Fehler')}
        </span>
        <h2>
          {t(
            'v3_property_edit_error_title',
            'Objektdaten konnten nicht geladen werden',
          )}
        </h2>
        <p className="mu">
          {t(
            'v3_error_text',
            'Die Verbindung zum Server wurde unterbrochen. Ihre Daten sind nicht betroffen.',
          )}
        </p>
        <div className="row wrap">
          <button
            type="button"
            className="btn pri"
            data-od-id="error-retry"
            onClick={onRetry}
          >
            <Svg
              size={16}
              d="M21 12a9 9 0 1 1-3-6.7M21 4v5h-5"
            />
            {t('errorwidget_retry', 'Erneut versuchen')}
          </button>
        </div>
      </div>
    </div>
  );
}
